import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { scoresQueries } from 'entities/scoring/model/userScore.query';

import type { IStateUserScore } from '../types';

const initialState: IStateUserScore = {
  score: 0,
  scoredUserData: '',
};

export const userScoreSlice = createSlice({
  name: 'userScore',
  initialState,
  reducers: {
    setScore: (state, { payload }: PayloadAction<number>) => {
      state.score = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(scoresQueries.endpoints.getScores.matchFulfilled, (state, { payload }) => {
      state.score = payload.score;
      state.scoredUserData = payload.scoredUserData;
    });
  },
});

export const { setScore } = userScoreSlice.actions;
